import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/apps.png'


const _withScopeId = n => (_pushScopeId("data-v-89953a8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "apps",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "t1" }
const _hoisted_5 = { class: "t2" }
const _hoisted_6 = { class: "toolbar" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-anzhuo" }, null, -1))
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-ios" }, null, -1))
const _hoisted_11 = { class: "t3" }

import i18, { State as I18State } from '@/store/i18';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const configData = computed(() => store.state.moviesConfig)
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].movieText)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(lang).software), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(lang).software_intro), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          class: "btn line round",
          href: _unref(configData).downloadUrl,
          target: "app"
        }, [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_unref(lang).software_android), 1)
        ], 8, _hoisted_7),
        _createElementVNode("a", {
          class: "btn line round",
          href: _unref(configData).downloadUrl,
          target: "app"
        }, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(_unref(lang).software_ios), 1)
        ], 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(lang).software_join), 1)
    ])
  ]))
}
}

})